import { LocalDictionaryFactory } from '../../api/api.module'

import { LoggerService } from '../../common/common.module'

import { IUserSession } from '../../../helpers/user-session'

import { GroupingLocationsTypeDetailDirectiveController } from './grouping-locations-types-details.directive.controller'

import { GroupingLocationTypeHelper } from '../grouping-locations-types.helper'
import { SYSTEM_SERVICE_NAME, SystemService } from '../../../services/system'

//#region Asset Imports

import * as TEMPLATE from './grouping-locations-types-details.tpl.html'

//#endregion

// Setup

export class GroupingLocationTypeDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$timeout', 'logger', 'localDictionary', SYSTEM_SERVICE_NAME, 'userSession', (
        $scope: any,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        systemService: SystemService,
        userSession: IUserSession
    ) => new GroupingLocationsTypeDetailDirectiveController(
        $scope,
        $q,
        $timeout,
        logger,
        localDictionary,
        systemService,
        userSession,
        GroupingLocationTypeHelper.REFERENCE_TYPE,
        GroupingLocationTypeHelper.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End